"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _variables = _interopRequireDefault(require("../utils/variables"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = function styles(theme) {
  return {
    otpInput: {
      color: "inherit",
      width: 32,
      border: "none",
      borderBottom: "1px #d1d1d1 solid",
      marginRight: 8,
      textAlign: "center",
      lineHeight: "48px",
      fontSize: "1.5em",
      zIndex: 9,
      position: "relative",
      transition: "all .5s ease-out",
      "-moz-appearance": "textfield",
      "&::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
        margin: 0
      },
      "&::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0
      },
      "&:focus": {
        borderColor: "black",
        zIndex: 10,
        outline: "none"
      }
    }
  };
};

var _default = styles;
exports["default"] = _default;